import cn from 'classnames';
import styles from './keto-button.module.css';

export interface KetoButtonProps
  extends React.DetailedHTMLProps<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {
  variant: 'contained';
  fullWidth?: boolean;
}

function KetoButton({
  children,
  className,
  fullWidth,
  ...props
}: KetoButtonProps) {
  return (
    <button
      type="button"
      className={cn(className, styles.contained, {
        [styles.fullWidth]: fullWidth,
      })}
      {...props}
    >
      {children}
    </button>
  );
}

export default KetoButton;
